import axios from '@/libs/api.request'

export const getCallQualityIndex = async (that, data) => {
    var res = await axios.request({
        url: '/loan/call/quality/index',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg || '请求失败');
        if (res.code == -2) {
            that.handleLogOut && that.handleLogOut();
            that.$router && that.$router.push({ name: 'login' });
        }
    }
    return res;
}

export const getCallQualityList = async (that, data) => {
    var res = await axios.request({
        url: '/loan/call/quality/getList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg || '请求失败');
        if (res.code == -2) {
            that.handleLogOut && that.handleLogOut();
            that.$router && that.$router.push({ name: 'login' });
        }
    }
    return res;
}

export const getCallQualityDetail = async (that, data) => {
    var res = await axios.request({
        url: '/loan/call/quality/getDetail',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg || '请求失败');
        if (res.code == -2) {
            that.handleLogOut && that.handleLogOut();
            that.$router && that.$router.push({ name: 'login' });
        }
    }
    return res;
}

export const getCallQualityAiDetail = async (that, data) => {
    var res = await axios.request({
        url: '/loan/call/quality/getAiDetail',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg || '请求失败');
        if (res.code == -2) {
            that.handleLogOut && that.handleLogOut();
            that.$router && that.$router.push({ name: 'login' });
        }
    }
    return res;
}

export const getCallQualityTrend = async (that, data) => {
    var res = await axios.request({
        url: '/loan/call/quality/trend',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg || '请求失败');
        if (res.code == -2) {
            that.handleLogOut && that.handleLogOut();
            that.$router && that.$router.push({ name: 'login' });
        }
    }
    return res;
}

export const getCallQualityRanking = async (that, data) => {
    var res = await axios.request({
        url: '/loan/call/quality/ranking',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg || '请求失败');
        if (res.code == -2) {
            that.handleLogOut && that.handleLogOut();
            that.$router && that.$router.push({ name: 'login' });
        }
    }
    return res;
}

export const retryCallQualityAi = async (that, data) => {
    var res = await axios.request({
        url: '/loan/call/quality/retryAi',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg || '请求失败');
        if (res.code == -2) {
            that.handleLogOut && that.handleLogOut();
            that.$router && that.$router.push({ name: 'login' });
        }
    }
    return res;
}